import { pSBC } from './index';
import { themes } from '../styles/themes';

const getColoresMapaCalor = (mapOpt, minValue, maxValue) => {
  // const gob = themes.gobernador.color;
  // const asa = themes.asamblea.color;
  // const alc = themes.alcalde.color;
  // const con = themes.consejo.color;
  // const jal = themes.jal.color;

  let min, max;
  if(mapOpt.theme !== undefined){
    min = pSBC(0.8, mapOpt.theme.colorBarra);
    max = mapOpt.theme.colorBarra;
    if ( maxValue === 0 && minValue === 0) {
      max = themes.color.sinInfo;
    }else if(minValue == maxValue){
      min = mapOpt.theme.colorBarra;
    }
  }
  if (minValue === 0) min = themes.color.sinInfo;
  return [min, max];
};

export default getColoresMapaCalor;
